<template>
	<div class="progressbarMain">
		<div class="progressbarContainer" ref="progressbarContainer">
			<div class="textBox">
				<div id="title" as>{{title}}</div>
				<!--<div id="title">Outstanding</div>-->
				<div id="percentageWord">{{percentage}}%</div>
			</div>
			<div class="progressbarBar" ref="progressbarBar" :style="{width: `${percentage}%`}"></div>
		</div>
	</div>
</template>

<script>
// @group Components
export default {
	components: {},
	props: {
		height: { type: Number, default: 24 },
		width: { type: Number, default: 100 },
		containerColor: { type: String, default: "grey" },

		//Public Properties
		title: { type: String, default: "Progress Bar" }, //Title that will be placed in the progress bar
		percentage: { type: Number, default: 50 }, //Percentage shown on the progress bar
		barColor: { type: String, default: "blue" } //The Color of the percentage bar
	},
	methods: {},
	mounted() {}
};
</script>

<style lang="scss" scoped>
@import "@/css/all.scss";

.progressbarContainer {
	width: 100%;
	height: 20px;
	position: relative;
	display: flex;
	align-items: center;
	background-color: #fff;
	border: solid 1px #aaa;
	border-radius: 20px;
}

.progressbarBar {
	height: 20px;
	position: absolute;
	background-color: #82b2ff;
	border-radius: 20px;
}

.progressbarMain {
	width: 100%;
	height: 25px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

#title,
#percentageWord {
	font-size: 12px;
	z-index: 1;
	color: midnightblue;
}

.textBox {
	position: absolute;
	width: 100%;
	height: 100%;
	padding: 0 3% 0 3%;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
</style>